import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';
import { serializeCarData } from '../utils/serializeCarData';

export const fetchLeadDetails = async (
  id,
  isModel = false,
  showToast = true
) => {
  let url = `${apiConfig('oem')}/v2/oem/leads/inventory-details?`;

  if (isModel) {
    url += `model_id=${id}`;
  } else {
    url += `id=${id}`;
  }
  const { response, error }: any = await getMethod({ endPoint: url });
  if (response) {
    if (response?.data) {
      return serializeCarData(response?.data);
    }
  }
  if (error) {
    if (showToast) {
      customToast({
        label: error?.message || 'Something went wrong',
        variant: 'criticalNotPriority',
      });
    }
  }
  return null;
};
